import {useSelector} from 'react-redux';
import {mobileScreen} from '../globalVariables/GlobalVariables';

const useMobile= ()=>(useSelector(s=>s.ui.windowWidth))<mobileScreen;

export default useMobile;